import { useSelector } from "react-redux";

import { GLOBAL_MEETING_DATA } from "../../../constants/PublicVariables";
import { HELP_ARTICLE } from "../../../constants/LDConstants";
import { CALL_BODY_SCREEN, DEVICE_TYPES } from "../../../constants/Constants";
import { dualStreamEnabled, isFeatureFlagDisabled, isFeatureFlagEnabled } from "../../../shared/utility";
import useLanguageChange from "../../../hooks/useLanguageChange";
import livePointerService from "../../LivePointer/livePointerService";
import { sendMsgForPointer } from "../../../shared/dataTrackFunction";
import { STATUS } from "../../../constants/LivePointerConstants";
import googleEvent from "../../../services/googleEvent";
import { EVENT_NAME } from "../../../constants/GTagConstants";
import { LogFirebase } from "../../../services/firestore";
import arMarkupService from "../../../services/MarkupService/arMarkupService";
import useCheckCallConnected from "../../../hooks/useCheckCallConnected";
import uploadFilesService from "../../../services/uploadFilesService";

const ARMarkupButton = () => {
    const isCallNotConnected = useCheckCallConnected();
    /* custome hook for getting updated localized value object for entire project 
    This will give localize value object for selected language
    Also will give updated localized value object when language change*/
    const localisedValues = useLanguageChange();

    const { currentCallBodyScreen } = useSelector((state) => state.commonReducer);
    const { streamingPartiIdentity, streamingDetails, isOpponentUserScreenSharing } = useSelector((state) => state.twilioEvents);
    const { pointerOn } = useSelector((state) => state.livePointer);

    const disabledButtonForWebMwebDualStream = () => {
        if (isCallNotConnected) return true;
        //    Check if user is Agent; dual stream is enabled; during dual stream, one participants view is expanded & streamining participant ID is exist, than check if device is supported of not
        if (GLOBAL_MEETING_DATA.isAgent && streamingPartiIdentity !== null) {
            const supportedDevices = [DEVICE_TYPES.ANDROID_BROWSER, DEVICE_TYPES.IOS_BROWSER, DEVICE_TYPES.DESKTOP];
            return supportedDevices.includes(streamingDetails.device_type);
        }
        return false;
    };

    const startARMarkup = () => {
        if (GLOBAL_MEETING_DATA.isAgent) {
            //// utility.removeSidebarZindex();
            if (pointerOn) {
                livePointerService.turnOffLivePointer();
                sendMsgForPointer(STATUS.OFF);
            }
            setTimeout(() => {
                googleEvent.logEvent(EVENT_NAME.AR_MARKUP_TAPPED);
                LogFirebase("ARMarkup", "Clicked_by_Agent", "");
                arMarkupService.startARMarkup();
            }, 100);
        }
    };

    const checkARMarkupButton = () => {
        if (!isCallNotConnected && !uploadFilesService.isUploadFilesView()) {
            if (!dualStreamEnabled()) {
                return isOpponentUserScreenSharing;
            }
        } else {
            return true;
        }
    };

    const isButtonDisabled = () => {
        return (
            isFeatureFlagDisabled("ARMarkup") ||
            disabledButtonForWebMwebDualStream() ||
            currentCallBodyScreen === CALL_BODY_SCREEN.NOTIFY_SCREEN ||
            checkARMarkupButton()
        );
    };

    const appRequiredHTMLText = localisedValues?.app_required?.replace(
        /<learnmore>/g,
        `<a class='text-dec-none' target='_blank' href='${HELP_ARTICLE.MEASUREMENT_APP_ARTICLES_NUMBER}' rel='noreferrer'> ${localisedValues?.learn_more} </a>`
    );

    return (
        <>
            {GLOBAL_MEETING_DATA.isAgent && isFeatureFlagEnabled("ARMARKUP") && isFeatureFlagDisabled("SHOWMEDUALSTREAM") && (
                <div className='action-button' data-testid='armarkup-buttom-component'>
                    <div className='action-button-in custom-tooltip top-tooltip left-tooltip tooltip-auto-width'>
                        <button className='call-action-btn' disabled={isButtonDisabled()} onClick={startARMarkup} data-testid='armarkup-button'>
                            <span className='action-button-icon'>
                                <span className='for-icon icon-ar-markup'></span>
                                <span className='beta-label'>Beta</span>
                            </span>
                            <span className='for-text'>{localisedValues?.AR_Markup_Lable}</span>
                        </button>
                        {(disabledButtonForWebMwebDualStream() || checkARMarkupButton()) && (
                            <div className='custom-tooltip-content text-nowrap'>
                                <div className='custom-tooltip-in'>
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: appRequiredHTMLText,
                                        }}
                                    ></p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default ARMarkupButton;
